module.exports = __webpack_public_path__ + "static/media/fr.0846f86e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fr.svg
// module id = 914
// module chunks = 0